import { render, staticRenderFns } from "./sqlResults.vue?vue&type=template&id=5c5a696f&scoped=true&"
import script from "./sqlResults.vue?vue&type=script&lang=js&"
export * from "./sqlResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5a696f",
  null
  
)

export default component.exports